import BaseAreaStack from "./private/BaseAreaStack.js";
import AnimatedPath from "./private/AnimatedPath.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default function AnimatedAreaStack(props) {
  return /*#__PURE__*/_jsx(BaseAreaStack, {
    ...props,
    PathComponent: AnimatedPath
  });
}